import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
import memoizeOne from "memoize-one";
import * as ThemeConstants from "./Constants";

export const createApplicationTheme = memoizeOne(() => {
	let theme = createMuiTheme({
		palette: {
			primary: {
				main: ThemeConstants.PALETTE_GREEN,
			},
			secondary: {
				main: ThemeConstants.PALETTE_ORANGE,
			},
			error: {
				main: ThemeConstants.PALETTE_RED,
			},
			text: {
				primary: ThemeConstants.PALETTE_BLACK
            }
		},
		typography: {
			fontFamily: ThemeConstants.FONT_FAMILY,
		},
		overrides: {
			MuiPaper: {
				root: {
					backgroundColor: ThemeConstants.PALETTE_DARK_WHITE
				}
			},
			MuiCssBaseline: {
				"@global": {
					
				},

			},
		}
	});

	theme = responsiveFontSizes(theme);
	return theme;
});

export const createApplicationThemeDark = memoizeOne(() => {
	let theme = createMuiTheme({
		palette: {
			type: "dark",
			primary: {
				main: ThemeConstants.PALETTE_BLUE,
				contrastText: ThemeConstants.PALETTE_BLACK
			},
			secondary: {
				main: ThemeConstants.PALETTE_ORANGE,
				contrastText: ThemeConstants.PALETTE_BLACK
			},
			error: {
				main: ThemeConstants.PALETTE_RED,
			},
			text: {
				primary: ThemeConstants.PALETTE_WHITE,
				secondary: ThemeConstants.PALETTE_LIGHT_GREY,
			}
		},
		typography: {
			fontFamily: ThemeConstants.FONT_FAMILY,
		},
		overrides: {
			MuiPaper: {
				root: {
					backgroundColor: ThemeConstants.PALETTE_DARK_BLUE
				}
			},
			MuiCssBaseline: {
				"@global": {

				},
			},
		}
	});

	theme = responsiveFontSizes(theme);
	return theme;
});